/**
 * Забирает базовую конфигурацию сервера из HTML
 * которая генерируется на сервере виджетом
 * 
 */
const ServerConfig = JSON.parse(
    document.getElementById('server-config-to-html-v1')
?.getAttribute('data-config') || '{}');

export default ServerConfig;